import { createSelector } from 'reselect';
import getPreferredDishes from './getPreferredDishes';

const getPreferredDishesProducts = createSelector(
  getPreferredDishes,
  section => {
    if (section) {
      const { products } = section;
      if (products?.length) {
        return products;
      }
    }
    return [];
  },
);

export default getPreferredDishesProducts;
